import { ModuleHeaderSlot } from "@tm/components"
import { useWorkTask } from "@tm/context-distribution"
import { Toolbar } from "@tm/controls"
import { useLocalization } from "@tm/localization"
import { ExportVoucherButton, useExportVoucherButtonEnabled } from "./ExportVoucherButton"
import { exportWorkTaskToShell, ShellExportButton } from "./ShellExportButton"

type Props = {
    showToolbar?: boolean
}

export function ExportSlot({ showToolbar }: Props) {
    const { translate, translateText } = useLocalization()
    const { workTaskId } = useWorkTask() ?? {}
    const exportVoucherButtonEnabled = useExportVoucherButtonEnabled(workTaskId, "basket-navigation")

    if (!workTaskId) {
        return null
    }

    const buttons = []

    if (exportVoucherButtonEnabled) {
        buttons.push(<ExportVoucherButton key="dms-export" workTaskId={workTaskId} disableWorkTaskCloseConfirmation />)
    }

    if (exportWorkTaskToShell) {
        buttons.push(
            <ShellExportButton key="shell-export" workTaskId={workTaskId} onExport={exportWorkTaskToShell}>
                {translate(3008)}
            </ShellExportButton>
        )
    }

    if (!buttons.length) {
        return null
    }

    if (showToolbar) {
        return <Toolbar title={translateText(1209)}>{buttons}</Toolbar>
    }

    return <ModuleHeaderSlot title={translateText(1209)}>{buttons}</ModuleHeaderSlot>
}
